import React from 'react';
import { Organization } from 'src/common/interfaces/organization.interface';
import { useCurrentOrganization } from 'src/store/organization';
import { useCurrentUser } from 'src/store/user';
import AdminOrganizationSwitcher from './admin-org-switcher';
import ManagementDropdownList from './list';

interface Props {
  onCreateNewOrganizationClicked: () => void;
}

const ManagementDropdownOrganizationList: React.FC<Props> = ({ onCreateNewOrganizationClicked }) => {
  const organizations = useCurrentUser((state) => state.organizations);
  const currentOrganization = useCurrentOrganization((state) => state.currentOrganization);
  const switchOrganization = useCurrentOrganization((state) => state.switchOrganization);

  const onChangeOrganization = (organizationId: any) => {
    if (currentOrganization.id === organizationId) {
      return false;
    }
    const org: any = organizations.find((organization: Organization) => organization.id === organizationId);

    if (org) {
      // TODO - if we intend to reload data through API calls, this will be the way to go
      // setCurrentOrganization(org);
      // apiGetWorkspaces(org.id)
      //   .then((data) => {
      //     setWorkspaces(data.workspaces);
      //   })
      //   .catch(() => {});
      switchOrganization(organizationId);
    }
  };

  return (
    <>
      <ManagementDropdownList
        selectedValue={currentOrganization.id}
        itemClassNameIterator={(item: Organization) => (!item.isRoot ? 'ml-2' : '')}
        items={organizations.sort((a: Organization, b: Organization) => (a.isRoot ? -1 : 1))}
        onSelectedItemChanged={onChangeOrganization}
      />
      <AdminOrganizationSwitcher />
    </>
  );
};

export default ManagementDropdownOrganizationList;
